import { Helmet } from "react-helmet-async";
import SolutionsSection from "../components/SolutionsSection";

export default function SolutionsPage() {
  return (
    <>
      <Helmet>
        <title>Solutions | Nexalus Infotech</title>
        <meta
          name="description"
          content="Explore Nexalus Infotech solutions for surveillance, access, safety, networks, and integrated building technology."
        />
      </Helmet>
      <main className="pt-24">
        <SolutionsSection />
      </main>
    </>
  );
}
